import React from 'react';
import {Input, Select, Form, Modal, DatePicker,Upload,message,Button,Icon,Col,Row,Drawer,Descriptions,Badge,Statistic} from 'antd';
import moment from 'moment';

const DerWareHouseOutDetail =(props)=>{
	
	const {onCancel,visible,item} =props
	
	let width = window.innerWidth <768 ? window.innerWidth*0.8 :window.innerWidth*0.35
	return (
	
	<Drawer   title={item.orderNo?<span>行方尾款订单编号:{item.orderNo}</span>:<span>无合同订单</span>}     placement="right"      closable={false}      onClose={onCancel}    visible={visible}  width={width}  >

	  	<Descriptions title="提货信息列表" layout="vertical" bordered>
		<Row><Col span={24}><pre style={{ margin: 0, textAlign: 'left' }}>
                 {JSON.stringify(item.goodsInfoList,null , 2)}<br/><br/><br/>
                  </pre></Col>				 
                 </Row>
		
	  </Descriptions>

      </Drawer>
	
	)

}


export default DerWareHouseOutDetail;
